import { FETCH_DOCS_OK, FETCH_MEMBERS_DOCS_OK } from "actions"

const initState = {
  docs: []
}

export default function (state = initState, action) {
  switch (action.type) {

    case FETCH_DOCS_OK: {
      return {
        ...state,
        docs: action.payload
      }
    }

    case FETCH_MEMBERS_DOCS_OK: {
      const { user_id, docs } = action.payload;
      return {
        ...state,
        [user_id]: docs
      }
    }

    default:
      return state
  }
}